import {TableBodyCell} from '@components/ui/table-atoms/TableAtoms.tsx'
import styled from 'styled-components'

export const StyledMoreActionsCell = styled(TableBodyCell)`
    background-color: transparent !important;
`
